export type HeroAspect = 'original' | '1:1' | '16:9' | '9:16' | '4:5' | '5:4';

export const HERO_ASPECT_OPTIONS: HeroAspect[] = ['original', '1:1', '16:9', '9:16', '4:5', '5:4'];

export const DEFAULT_HERO_ASPECT: HeroAspect = 'original';

// Only maps non-original ratios (original is handled specially)
export const HERO_ASPECT_CSS: Partial<Record<HeroAspect, string>> = {
    '1:1': '1 / 1',
    '16:9': '16 / 9',
    '9:16': '9 / 16',
    '4:5': '4 / 5',
    '5:4': '5 / 4',
};

export const normalizeHeroAspect = (value: string | null | undefined): HeroAspect => {
    if (!value || value === '') return DEFAULT_HERO_ASPECT;

    // Direct match
    if (HERO_ASPECT_OPTIONS.includes(value as HeroAspect)) {
        return value as HeroAspect;
    }

    // Try to fix formats like "16/9" or "16 / 9" -> "16:9"
    // Also handle "16 : 9" -> "16:9"
    const normalized = value.replace(/\s/g, '').replace('/', ':');

    if (HERO_ASPECT_OPTIONS.includes(normalized as HeroAspect)) {
        return normalized as HeroAspect;
    }

    return DEFAULT_HERO_ASPECT;
};
